import {
  HesiExamRemediationSettingsDto,
  RecommendationContentTypeDto,
  RemediationActivityTypeDto,
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import {
  AssessmentGoalDto,
} from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { RemediationBaseState } from '../../hocs/with-remediation-base/withRemediationBase.hoc';
import { getContentTypesFromActivityType } from '../../utilities/remediation.utilities';
import { DATE_SECONDARY } from '../../constants/date.constants';
import moment from 'moment';
import { getProduct, getProductConfig } from '../../utilities/product.utilities';

export const getContentTypesFromAssessmentGoal = (assessmentGoal: AssessmentGoalDto, baseState: RemediationBaseState): RecommendationContentTypeDto[] => {
  return getContentTypesFromActivityType(assessmentGoal.type as RemediationActivityTypeDto, baseState);
};

export const getStudentHomePageTitle = (baseState: RemediationBaseState): string => {
  if (!baseState.remediationAssignmentWithSources) {
    return null;
  }

  const { homePageTitle } = getProductConfig(getProduct(baseState.remediationAssignmentWithSources));

  const title = homePageTitle
      || baseState.remediationAssignmentWithSources?.eolsAssignment?.title
      || 'Missing title';
  const settings = baseState.remediationAssignmentWithSources?.remediationAssignment?.settings;
  const scheduledEndDate = 'scheduledEndDate' in (settings ?? {}) ? (settings as HesiExamRemediationSettingsDto).scheduledEndDate : null;
  if (!scheduledEndDate) {
    return title;
  }
  return `${title}, ${moment(scheduledEndDate).format(DATE_SECONDARY)}`;
}
